import * as React from 'react';
import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/1992-IBIS.jpg');

const IbisContent = () => {
    return (
        <>
            <TimelineVideo videoId="yprPDxY-JVg" imagePreview={VideoPreview} />
            <h4>
                The IBIS-I clinical trial commences patient recruitment
            </h4>
            <p>
                The IBIS-I clinical trial commences patient recruitment and aims to determine if tamoxifen can prevent breast cancer in women with a higher than average risk of developing the disease. The study found that tamoxifen reduced the incidence of breast cancer by one third in these higher (or above average) risk women. BCT recruited more than 2,670 women to this international clinical trial across Australia and New Zealand and Professor John Forbes AM was the Breast Cancer Trials Study Chair.
            </p>
        </>
    );
}

export default IbisContent;